import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
// react library that truncates and adds ellipses to multiline text
import ClampLines from 'react-clamp-lines';
import classes from './LogPostItemSmall.module.css';
import { categoryImages, formatSimpleDate, getAuthorName, getRgbFromColorName, truncateText, utcToLocalDateTime } from 'shared/utility';

const logPostItemSmall = (props) => {
  let categoryImage = null;
  const containerClasses = [classes.PostItemContainer];
  if (props.type) containerClasses.push(classes[props.type]);
  if (props.categoryImage) {
    categoryImage = categoryImages.find((category) => category.name === props.categoryImage);
  }
  const dateModified = props.post && props.post.DatePostUpdated ? formatSimpleDate(utcToLocalDateTime(props.post.DatePostUpdated).toString()) : '';
  const dateAdded = props.post && props.post.DateCreated ? formatSimpleDate(utcToLocalDateTime(props.post.DateCreated).toString()) : '';
  let author = getAuthorName(props.post.NickName, props.post.FirstName);
  author =
    props.type === 'SideBySide'
      ? props.sortBy === 'DateStart'
        ? truncateText(author, 15)
        : truncateText(author, 10)
      : props.sortBy === 'DateStart'
      ? truncateText(author, 30)
      : truncateText(author, 20);
  const footerDate =
    props.sortBy === 'DateStart' ? null : (
      <p className={classes.DateModified}>{props.sortBy === 'DatePostUpdated' ? `Modified ${dateModified}` : `Added ${dateAdded}`}</p>
    );
  return (
    <div>
      <div className={containerClasses.join(' ')} onClick={() => props.handleSelect(props.post.PostId, props.page)}>
        {props.isUnread ? <FontAwesomeIcon icon="circle" className={classes.UnreadIcon} /> : null}
        <div className={classes.ThumbnailContainer}>
          {props.postImageUrl ? (
            <div className={classes.LogPostImageContainer}>
              <img src={props.postImageUrl} alt={props.post.Name} />
            </div>
          ) : (
            <div
              style={{
                backgroundColor: props.post.Color ? getRgbFromColorName(props.post.Color) : 'rgb(108, 162, 183)',
              }}
              className={classes.DefaultImage}
            />
          )}
        </div>
        <div className={classes.ContentsContainer}>
          <div className={classes.InnerContainer}>
            {categoryImage ? (
              <div className={classes.ContentType}>
                <categoryImage.image />
              </div>
            ) : null}
            <div className={classes.LowerContentsContainer}>
              <ClampLines id={props.post.PostId} text={props.post.Name} buttons={false} lines={2} delay={600} className={classes.PostTitle} />
              <p className={classes.PostDate}>{props.date}</p>
              <div className={classes.Footer}>
                <p className={classes.PostAuthor} style={{ color: props.post.Color ? getRgbFromColorName(props.post.Color) : 'rgb(108, 162, 183)' }}>
                  {author}
                </p>
                {footerDate}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default logPostItemSmall;
